/**
 * Instagram Official Embed HTML -> Minimal Embed HTML
 *
 * Converts Instagram official embed snippet (blockquote + script, often very large)
 * into a controlled minimal embed HTML:
 * - Extract permalink from data-instgrm-permalink / anchor href / plain URL
 * - Normalize to https://www.instagram.com/(p|reel|tv)/<id>/ (no query/hash)
 * - Return minimal <blockquote> + <script async src="https://www.instagram.com/embed.js"></script>
 */

import {
    extractInstagramPermalinkFromOfficialEmbedHtml,
    normalizeInstagramPermalinkForEmbed,
} from "./instagram-embed-extractor";
import { CommonUtils } from "../../util/common-utils";

export { extractInstagramPermalinkFromOfficialEmbedHtml, normalizeInstagramPermalinkForEmbed };

/**
 * Convert official embed HTML into minimal embed HTML.
 */
export function convertInstagramOfficialEmbedHtmlToMinimalEmbedHtml(officialEmbedHtml: string): string | null {
    const extracted = extractInstagramPermalinkFromOfficialEmbedHtml(officialEmbedHtml);
    if (!extracted) {
        return null;
    }

    const permalink = normalizeInstagramPermalinkForEmbed(extracted);
    if (!permalink) {
        return null;
    }

    const permalinkEscaped = CommonUtils.escapeHtmlAttribute(permalink);

    return (
        "<blockquote\n" +
        '  class="instagram-media"\n' +
        `  data-instgrm-permalink="${permalinkEscaped}"\n` +
        '  data-instgrm-version="14"\n' +
        '  style="background:#fff; max-width:540px; width:100%; margin:0 auto;"\n' +
        "></blockquote>\n\n" +
        '<script async src="https://www.instagram.com/embed.js"></script>\n'
    );
}
